export default __webpack_public_path__ + "static/media/EM1480.34I-38128_-26495_0.e9f6f817.jpg";